module.exports = __webpack_public_path__ + "static/img/screen.7180fc04.png";